import { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { apiFetch } from '@/lib/apiFetch'
import MagnumSays from '@/components/MagnumSays'

export default function ConfirmEmailPage() {
  const history = useHistory()
  const location = useLocation()
  const { refresh } = useAuth()
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying')
  const [errorMessage, setErrorMessage] = useState('')

  const params = new URLSearchParams(location.search)
  const token = params.get('token')

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setErrorMessage('No verification token found.')
      return
    }

    let cancelled = false
    ;(async () => {
      try {
        await apiFetch('/onboarding/verify', {
          method: 'POST',
          body: JSON.stringify({ token }),
        })
        if (cancelled) return
        await refresh()
        setStatus('success')
        setTimeout(() => history.replace('/onboarding'), 1500)
      } catch (err: any) {
        if (cancelled) return
        setStatus('error')
        setErrorMessage(err.message || 'Verification failed.')
      }
    })()

    return () => { cancelled = true }
  }, [token])

  if (status === 'verifying') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <MagnumSays>Checking your email link... one sec!</MagnumSays>
      </div>
    )
  }

  if (status === 'success') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="space-y-4">
          <MagnumSays variant="success">
            <p className="font-medium">You're in!</p>
            <p className="mt-1 text-muted-foreground">Email confirmed. Let's get you set up...</p>
          </MagnumSays>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-6">
        <MagnumSays variant="warning">
          <p className="font-medium">Hmm, that didn't work.</p>
          <p className="mt-1 text-muted-foreground">{errorMessage}</p>
        </MagnumSays>
        <div className="text-center">
          <button
            onClick={() => history.push('/signup')}
            className="px-6 py-2.5 bg-primary text-primary-foreground rounded-lg font-semibold hover:opacity-90 transition"
          >
            Try again
          </button>
        </div>
      </div>
    </div>
  )
}
